export default "__VITE_ASSET__g$mBOXIM__"